module.exports = __webpack_public_path__ + "img/badge-od.4a2930ee.png";